import React from 'react';
import PropTypes from 'prop-types';
import iconColorsMap from './colors';

const Folder = ({ fill, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={fill}
    {...props}
  >
    <path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
  </svg>
);
Folder.propTypes = { fill: PropTypes.string };
Folder.defaultProps = { fill: iconColorsMap.mainicon };

export default Folder;
